//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/birthday/rule.vue